<script>
  import { urlServeur, tabcouleur } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";
  let rows;

  /**
   *  recherche des datas sur le serveur
   * api_employe/employes?id=xxx&nom=nom_personne&parti=0|1
   */
  const fectPersonnesParties = async () => {
    const response = await fetch(urlServeur + "/api_employe/employes?parti=1");

    if (response.ok) {
      const result = await response.json();

      rows = result.payload;
      //console.log(rows);
      return rows;
    } else {
      throw new (Error(text))();
    }
  };

  let promise = fectPersonnesParties();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <h3>Liste complète</h3>
  <table class="table table-responsive table-success">
    <thead>
      <tr>
        <td>Nom</td>
        <td>Poste</td>
        <td>Parti</td>
        <td>Old</td>
      </tr>
    </thead>
    <tbody>
      {#each elements as element}
        <tr>
          {#if element.EM_PARTI_LE <= "1970-01-01"}
            <td
              >{element.EM_NOM}<span class="cadre text-danger"
                >{element.EM_CADRE == 1 ? "  * " : ""}</span
              ></td
            >
          {:else}
            <td class="text-danger"
              ><del
                >{element.EM_NOM}<span
                  >{element.EM_CADRE == 1 ? "  * " : ""}</span
                ></del
              ></td
            >
          {/if}
          <td style="background-color : #{tabcouleur[element.EM_POSTE]}"
            >{element.EM_POSTE.substring(0, 6)}</td
          >
          <td
            ><span class="dates">{element.EM_ENTRE_LE}</span>
            <br /><span class="dates">
              {element.EM_PARTI_LE <= "1970-01-01" ? "-" : element.EM_PARTI_LE}
            </span></td
          >
          <td>{element.OLD}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{/await}

<style>
  .table {
    font-size: 0.6em;
    padding: -1px;
    margin: 0px;
  }
  .dates {
    padding: 2px;
    margin-bottom: -5 px;
    margin-top: -5 px;
    line-height: 0.9em;
    text-align: center;
  }
  .cadre {
    font-size: 1.2em;
    font-weight: bold;
  }
</style>
